import React, {useEffect} from "react";

import {Container} from "@pg-design/grid-module";
import {pb} from "@pg-design/helpers-css";

import {CreditOffersList} from "../components/credit_offers/CreditOffersList";
//import {CreditOffersDescription} from "../components/CreditOffersDescription";
import {CreditBreadcrumbs, CreditBreadcrumbType} from "../components/CreditsBreadcrumbs";
import {CreditViewEvent} from "../tracking/analytics/credit_view_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";

export const CreditOffersListView = () => {
    useEffect(() => {
        CreditViewEvent({view_type: CreditAlgolyticsViewType.BANK_OFFERS});
    }, []);

    return (
        <div css={pb(9)}>
            <CreditBreadcrumbs breadcrumbType={CreditBreadcrumbType.OFFERS} />
            <Container>
                <CreditOffersList />
                {/*
                <CreditOffersDescription />
                */}
            </Container>
        </div>
    );
};
import React, {useEffect} from "react";

import {Container} from "@pg-design/grid-module";
import {pb} from "@pg-design/helpers-css";

import {CreditOffersList} from "../components/credit_offers/CreditOffersList";
//import {CreditOffersDescription} from "../components/CreditOffersDescription";
import {CreditBreadcrumbs, CreditBreadcrumbType} from "../components/CreditsBreadcrumbs";
import {CreditViewEvent} from "../tracking/analytics/credit_view_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";

export const CreditOffersListView = () => {
    useEffect(() => {
        CreditViewEvent({view_type: CreditAlgolyticsViewType.BANK_OFFERS});
    }, []);

    return (
        <div css={pb(9)}>
            <CreditBreadcrumbs breadcrumbType={CreditBreadcrumbType.OFFERS} />
            <Container>
                <CreditOffersList />
                {/*
                <CreditOffersDescription />
                */}
            </Container>
        </div>
    );
};
